import { defineComponent as _defineComponent } from 'vue'
import ClientSelect from "@/components/widgets/input/ClientSelect.vue"
import { ref } from "vue"
import { useNewProjectContext } from "../context/useNewProjectContext"
import { Client } from "@/gql"


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectClient',
  emits: ["goto-next", "goto-prev"],
  setup(__props, { emit }) {

const clientValue = ref<Client | null>(null)
const showAddClientDialog = ref(false)
const { updateClientForm } = useNewProjectContext()



const onSubmit = () => {
  if (!clientValue.value) return

  updateClientForm({ id: String(clientValue.value.id) })
  emit("goto-next")
}

return { __sfc: true,clientValue, showAddClientDialog, updateClientForm, emit, onSubmit, ClientSelect }
}

})